// src/components/Loader.js

import React, { useEffect, useState, useRef } from 'react';
import Lottie from 'lottie-react';
import animationData from './logo-loader.json';

const Loader = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lottieSize, setLottieSize] = useState({ width: 400, height: 400 });
  const lottieRef = useRef();

  useEffect(() => {
    // 1. Logika Responsive (Max 991px)
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setLottieSize({ width: 200, height: 200 });
      } else {
        setLottieSize({ width: 400, height: 400 });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    // 2. Atur Kecepatan (Misal 2.5x lebih cepat)
    if (lottieRef.current) {
      lottieRef.current.setSpeed(2.5); 
    }

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Jika sudah tidak visible, jangan render apapun
  if (!isVisible) return null;

  return (
    <div className="loader-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ffffff', // Pastikan warna solid agar website di belakang tertutup
      zIndex: 9999, // Angka tinggi supaya di atas semua elemen website
    }}>
      <div className="loader-container">
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop={false} // JANGAN di-loop (hanya sekali jalan)
          autoplay={true}
          style={lottieSize}
          // KUNCI UTAMA: Baru sembunyikan loader saat animasi benar-benar SELESAI
          onComplete={() => {
            console.log("Animasi selesai, menutup loader...");
            setIsVisible(false);
          }}
        />
      </div>
    </div>
  );
};

export default Loader;